<ng-container *ngIf="featuredOffers$ | async as featuredOffers">
  <div class="row" *ngIf="!!featuredOffers.length">
    <div class="col-12" *ifScreenSize="screenType.Mobile">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let offer of featuredOffers">
          <ng-template carouselSlide>
            <fgbcl-card-linking-single-featured-offer
              [featuredOffer]="offer"
              [currentLcid]="currentLcid"
            ></fgbcl-card-linking-single-featured-offer>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <ng-container *ifScreenSize="screenType.Desktop">
      <ng-container *ngFor="let offer of featuredOffers">
        <div class="col-4">
          <fgbcl-card-linking-single-featured-offer
            [featuredOffer]="offer"
            [currentLcid]="currentLcid"
          ></fgbcl-card-linking-single-featured-offer>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
